import clsx from 'clsx';
import React, { createContext, useContext } from 'react';

const CardVariantContext = createContext();

export const useCardVariant = () => useContext(CardVariantContext);

/**
 * @param {{
 *  variant: "default" | "root" | "card"
 * }}
 */
const Card = ({ children, variant = 'default', className, ...props }) => {
  return (
    <CardVariantContext.Provider value={variant}>
      <div
        className={clsx(
          {
            'p-4': variant === 'default',
            'py-6': variant === 'root',
            'bg-white rounded drop-shadow m-4 border border-gray-50 last:border-none py-4':
              variant === 'card',
          },
          className,
        )}
        {...props}
      >
        {children}
      </div>
    </CardVariantContext.Provider>
  );
};

export default Card;
